'use client';

import { c as _c } from "react/compiler-runtime";
import { TriangleAlertIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
interface PlaygroundErrorProps {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}
export default function PlaygroundError(t0) {
  const $ = _c(32);
  const {
    error,
    reset
  } = t0;
  const t = useTranslations("playground_page.error");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TriangleAlertIcon />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <CardTitle className="flex items-center gap-1 font-semibold text-foreground text-xl">{t1}{t2}</CardTitle>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <CardDescription>{t4}</CardDescription>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <CardHeader>{t3}{t5}</CardHeader>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== error.digest) {
    t7 = error.digest && <p className="mt-1 font-mono text-muted-foreground text-xs">Error ID: {error.digest}</p>;
    $[12] = error.digest;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <CardContent className="min-w-sm">{t7}</CardContent>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("retry");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== reset || $[19] !== t9) {
    t10 = <Button onClick={reset}>{t9}</Button>;
    $[18] = reset;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("reload");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <Button variant="outline" onClick={_temp}>{t11}</Button>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t12) {
    t13 = <CardFooter className="flex items-center justify-end gap-2">{t10}{t12}</CardFooter>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t13 || $[29] !== t6 || $[30] !== t8) {
    t14 = <div className="flex h-[calc(100dvh-49px)] flex-col items-center justify-center p-4"><Card>{t6}{t8}{t13}</Card></div>;
    $[28] = t13;
    $[29] = t6;
    $[30] = t8;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}
function _temp() {
  return window.location.reload();
}